import PropTypes from 'prop-types';
import React from 'react';

const Badge = ({ badgeContent, badgeColor, isAriaHidden = false }) => {
  return (
    <>
      <span
        aria-hidden={isAriaHidden}
        badge-color={badgeColor}
        className="badge"
      >
        {badgeContent}
      </span>
      <style jsx>{`
        .badge {
          color: #fff;
          background-color: ${badgeColor};
          display: inline-block;
          padding: 2px;
          font-size: 10px;
          font-weight: 700;
          line-height: 1;
          min-width: 12px;
          text-align: center;
          white-space: nowrap;
          vertical-align: baseline;
          border-radius: 10px;
        }
      `}</style>
    </>
  );
};

export default Badge;

Badge.propTypes = {
  badgeColor: PropTypes.string.isRequired,
  badgeContent: PropTypes.string.isRequired,
  isAriaHidden: PropTypes.bool,
};
